import {Component, OnInit, ViewChild} from '@angular/core';
import {IOption} from "ng-select";
import {Location} from "@angular/common";
import {BsDatepickerConfig, BsModalRef} from "ngx-bootstrap";
import {BsModalService} from 'ngx-bootstrap/modal';
import {HelperService} from "../services/helper.service";
import {LossPreventionAccessService} from "../services/loss-prevention-access.service";
import {RilrService} from "../services/rilr.service";
import {NgxSpinnerService} from "ngx-spinner";

@Component({
  selector: 'app-corrective-action-forward-almah',
  templateUrl: './corrective-action-forward-almah.component.html',
  styleUrls: ['./corrective-action-forward-almah.component.scss'],
  providers: [RilrService, HelperService, LossPreventionAccessService]
})
export class CorrectiveActionForwardAlmahComponent implements OnInit {

  public masterDataNew: any = {};
  public employeeOption: Array<IOption> = [];
  public departmentArr: Array<IOption> = [];
  public companySystemID = +this.helperService.getSelectedCompanyId();

  public actionAssignedArr: any = [
    {value: 1, label: 'Individual'},
    {value: 2, label: 'Department'}
  ];
  public htmlErrorMessage: string;
  @ViewChild('errorMessageHtml') errorMessageHtml: any;

  constructor(public bsModalRef: BsModalRef,
              private modalService: BsModalService,
              private rilrService: RilrService,
              private location: Location,
              private spinner: NgxSpinnerService,
              private lossPreventionAccessService: LossPreventionAccessService,
              private helperService: HelperService) {
  }

  ngOnInit() {
    setTimeout(() => {
      if (this.masterDataNew.actionAssignedTo == 1 || this.companySystemID == 3) {
        this.getEmployeesEdit(this.masterDataNew.personResEmpID);
      }

    }, 0);

  }

  public typehead(value: any): void {
    let that = this;
    if (value.length > 0) {
      that.getEmployees(value);
    } else {
      that.employeeOption = [];
    }
  }

  getEmployees(value: any) {
    const that = this;
    that.rilrService
      .getTypeheadEmployees()
      .get({
        'search': value,
        'companySystemID': that.companySystemID
      })
      .subscribe(resp => {
        var tempOption = resp.data.data;
        that.employeeOption = [];
        that.employeeOption = that.helperService.setSelect2DropDownOptionsConcatLabelThree(tempOption, "employeeSystemID", "empName", "countryName", "description");
      }, (err) => {
        console.log(err);
        that.employeeOption = [];
      });
  }

  getEmployeesEdit(value: any) {
    const that = this;
    that.rilrService
      .getTypeheadEmployees()
      .get({
        'search': value,
        'companySystemID': that.companySystemID
      })
      .subscribe(resp => {
        var tempOption = resp.data.data;
        that.employeeOption = [];
        that.employeeOption = that.helperService.setSelect2DropDownOptionsConcatLabelThree(tempOption, "employeeSystemID", "empName", "countryName", "description");
        setTimeout(() => {
          that.masterDataNew.personResEmpSystemID = that.helperService.setSelectedValue(that.masterDataNew.personResEmpSystemID);
        }, 0);

      }, (err) => {
        console.log(err);
        that.employeeOption = [];
      });
  }

  showErrorHtml() {
    setTimeout(() => {
      this.errorMessageHtml.show();
    }, 0);
  }

  closeModal() {
    this.bsModalRef.hide();
    this.modalService.setDismissReason('corrective_action_forward');
  }

  storeCACommentsForward() {
    const that = this;
    that.spinner.show();
    that.masterDataNew.companySystemID = that.companySystemID;
    that.masterDataNew.host = window.location.origin;
    that.rilrService
      .storeCorrectiveACommentsForwardAlmaha()
      .post(that.masterDataNew)
      .subscribe(resp => {
        that.spinner.hide();
        that.closeModal();
      }, (error) => {
        that.htmlErrorMessage = error.data.message;
        that.showErrorHtml();
        that.spinner.hide();
      });

  }

}



// WEBPACK FOOTER //
// /app/src/app/corrective-action-forward-almah/corrective-action-forward-almah.component.ts